import { render, staticRenderFns } from "./SpecialOfferReceiptView.vue?vue&type=template&id=60bbb390&scoped=true&"
import script from "./SpecialOfferReceiptView.vue?vue&type=script&lang=ts&"
export * from "./SpecialOfferReceiptView.vue?vue&type=script&lang=ts&"
import style0 from "./SpecialOfferReceiptView.vue?vue&type=style&index=0&id=60bbb390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bbb390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
